import {getCookie, getLang, setCookie} from '../../common/Utils';
import Modal from '../modal/Modal';
import {checkCookie} from './checkCookie';
import {ncBannerI18n, ncBannerOptions} from '../../interface/ICommonbanner';
import { l10nAllLang } from '../../common/L10n';


/**
 * @category Commonbanner
 * @description
 * 이미지 배너
 * 메인페이지에서만 노출
 * 그만보기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */


class ImageLayer {
    isCookieApply: boolean;
    constructor(_isMain: boolean = false, _isLauncher:boolean = false, _data:ncBannerOptions) {

        this.isCookieApply = checkCookie();
        let thisIsCookieApply = this.isCookieApply && getCookie(_data.imageCookie);

        if( !_isMain || !_data.showImageBanner || thisIsCookieApply){
            return;
        }

        if ( _isLauncher && !_data.movieLauncherShow) {
            return;
        }

        let customClassName = ( _data.imageOrientationVertical)? 'imgBannerVertical' : '' ;

	    let lang = getLang() || 'en';	
        let l10n = l10nAllLang[lang].commonBanner;

        let ncBannerModalImage = new Modal({
            
            id: 'NC-banner-modal',
            className: customClassName,
            contents: `
                ${_data.imageLink != ''?`
                    ${_data.imageLinkNewWindow ? `
                    <div class="nc-banner-modal-mobile"><a href="${_data.imageLink}" target="_blank"><img src="${_data.imageMobileBG}"></a></div><div class="nc-banner-modal-pc"><a href="${_data.imageLink}" target="_blank"><img src="${_data.imagePcBG}"></a></div>
                    ` :`
                    <div class="nc-banner-modal-mobile"><a href="${_data.imageLink}"><img src="${_data.imageMobileBG}"></a></div><div class="nc-banner-modal-pc"><a href="${_data.imageLink}"><img src="${_data.imagePcBG}"></a></div>
                    `}
                `
                 : `
                 <div class="nc-banner-modal-mobile"><img src="${_data.imageMobileBG}"></div><div class="nc-banner-modal-pc"><img src="${_data.imagePcBG}"></div>
                 `}`,
            primaryBtnText: l10n.stop_watching,
            cancelBtnText: l10n.close,
            willOpen: ()=>{},
            didClose: (_result:boolean)=>this.addEvents( _result, _data )
        });            
        

        ncBannerModalImage.open();

    }
    
    addEvents(_result: boolean, _data:ncBannerOptions ){        
        if(_result) {
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.imageCookie, "true", 999, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.imageCookie, "true", 999, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.imageCookie, "true", 999, '.plaync.com'); // 쿠키 사용
            }            
        }
    }

}
export default ImageLayer;